import ReactGA from 'react-ga';
import React from 'react'
import * as column from './columns'
import { Table } from 'antd'
import Graph from './Graph'

class Maintenance extends React.Component {
  componentDidMount(){
    ReactGA.pageview('/maintenance');
  }

  render () {
    var workshopData = [];

    var countTruck = [];
    var countRig = [];
    var countPlant = [];
    var countVehicle = [];

    if (this.props.workshop) {
      for (var i = 0; i < this.props.workshop.length; i++) {
        if (this.props.workshop[i].form_values.ef64 === "Maintenance Sheet") {
          if (this.props.workshop[i].form_values["2bc1"]) { var d1 = " • " + this.props.workshop[i].form_values["2bc1"]  } else { d1 = "" }
          if (this.props.workshop[i].form_values["2cd7"]) { var d2 = " • " + this.props.workshop[i].form_values["2cd7"]  } else { d2 = "" }
          if (this.props.workshop[i].form_values["9bb8"]) { var d3 = " • " + this.props.workshop[i].form_values["9bb8"]  } else { d3 = "" }
          if (this.props.workshop[i].form_values["25ee"]) { var d4 = " • " + this.props.workshop[i].form_values["25ee"]  } else { d4 = "" }
          if (this.props.workshop[i].form_values["36fa"]) { var d5 = " • " + this.props.workshop[i].form_values["36fa"]  } else { d5 = "" }
          if (this.props.workshop[i].form_values["253d"]) { var d6 = " • " + this.props.workshop[i].form_values["253d"]  } else { d6 = "" }
          if (this.props.workshop[i].form_values["2871"]) { var d7 = " • " + this.props.workshop[i].form_values["2871"]  } else { d7 = "" }
          if (this.props.workshop[i].form_values["3394"]) { var d8 = " • " + this.props.workshop[i].form_values["3394"]  } else { d8 = "" }
          if (this.props.workshop[i].form_values["c27d"]) { var d9 = " • " + this.props.workshop[i].form_values["c27d"]  } else { d9 = "" }
          var description = d1 + d2 + d3 + d4 + d5 + d6 + d7 + d8 + d9;
          if (this.props.workshop[i].form_values["5b6b"]) {
            if ( this.props.workshop[i].form_values["5b6b"].choice_values[1]) { var vehicle =  this.props.workshop[i].form_values["5b6b"].choice_values[1]  }
            else if (this.props.workshop[i].form_values["5b6b"].other_values[0]) {
              vehicle = this.props.workshop[i].form_values["5b6b"].other_values[0]
            } else { vehicle = "" }
            if (this.props.workshop[i].form_values['5b6b'].choice_values['0'] === 'Vehicle') {  countVehicle++  }
            if (this.props.workshop[i].form_values['5b6b'].choice_values['0'] === 'Plant') {  countPlant++  }
            if (this.props.workshop[i].form_values['5b6b'].choice_values['0'] === 'Rig') {  countRig++  }
            if (this.props.workshop[i].form_values['5b6b'].choice_values['0'] === 'Truck') {  countTruck++  }
          }
          workshopData.push({
            id: this.props.workshop[i].id,
            date: this.props.workshop[i].form_values["4bc0"],
            description: description,
            on: vehicle,
            completedBy: this.props.workshop[i].form_values.fdcd.choice_values["0"]
          });
        }
      }
      workshopData.sort((a, b) => {
        var aDate = a.date;
        var bDate = b.date;

        return (aDate > bDate) ? -1 : 1;
      });
    }
    function checkData() { if (workshopData.length === 0) { return true } else { return false }}
    return(
      <div>
        <h1>Maintenance</h1>
        <h4>This graph shows the maintenance completed on specific categories.</h4>
        <Graph data={[countTruck, countRig, countPlant, countVehicle]} />
        <h1>Details</h1>
        <Table
          pagination={false}
          id='boresTableTwo'
          loading={checkData()}
          className='tableResizer'
          columns={column.workshopList}
          expandedRowRender={record => <p style={{ margin: 0 }}>{record.description}</p>}
          dataSource={workshopData}
            rowKey='id'
            size="small" />
      </div>

    )
  }
}

export default Maintenance;



// WEBPACK FOOTER //
// ./src/components/Maintenance/index.js
